import {
  CalendarOutlined,
  CheckCircleOutlined,
  EditOutlined,
  HighlightOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Col, Modal, Row, Tag } from "antd";
import React, { useState } from "react";
import Contrainer from "../../components/Contrainer/Contrainer";
import Text from "../../components/Text/Text";
import color from "../../resource/color";
import icon from "../../resource/icon";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import {
  SCORE_MAPPING,
  SCORE_MAPPING_COLOR,
  SCORE_MAPPING_DES,
} from "../../definitions/score";
import { myEvaluationDatasource } from "../../datasource/myEvaluationDatasource";
import TextArea from "antd/es/input/TextArea";

const ConsentPerformance: React.FC = () => {
  const DateFormat = "MMMM D, YYYY HH:mm";
  const navigate = useNavigate();
  const location = useLocation();
  const { getData } = location.state || {};
  const profile = JSON.parse(localStorage.getItem("rainbowProfile")!);

  const [openAcknowledge, setOpenAcknowledge] = useState<boolean>(false);
  const [data, setData] = useState<any>(getData);
  const [sign, setSign] = useState<boolean>(getData.isEmployeeSubmit); //for show signature

  const submitConsent = async () => {
    await myEvaluationDatasource
      .submitConsent({
        employeeId: profile.employeeId,
        pmsId: data.pmsId,
        isEmployeeSubmit: true,
      })
      .then((res) => {
        if (res.success) {
          const mapData = { ...data };
          setSign(false);
          mapData.isEmployeeSubmit = res.responseData.isEmployeeSubmit;
          mapData.employeeSubmitDate = res.responseData.employeeSubmitDate;
          setData(mapData);
        }
      });
  };

  return (
    <>
      <Contrainer>
        <Row gutter={8}>
          <Col>
            <Text
              level={6}
              style={{ cursor: "pointer" }}
              onClick={() => navigate(-1)}
            >
              My Evaluation
            </Text>
          </Col>
          <Col>
            <Text level={6}>/</Text>
          </Col>
          <Col>
            <Text
              color="navy"
              level={6}
              fontWeight={400}
              style={{ cursor: "default" }}
            >
              {data?.pmsYear}{" "}
              {data?.pmsMonth === "13" ? "Mid Year" : "Final Year"} Evaluation
            </Text>
          </Col>
        </Row>
        <br />
        <Contrainer
          style={{
            backgroundColor: "#F3F4FB",
            borderRadius: "24px",
            padding: "25px",
            borderColor: color.gray,
            borderStyle: "solid",
            borderWidth: 1,
          }}
        >
          <Row justify={"start"} gutter={8}>
            <Col span={18}>
              <Row gutter={8}>
                <Col>
                  <Text level={2} fontWeight={700}>
                    {data?.pmsYear}{" "}
                    {data?.pmsMonth === "13" ? "Mid Year" : "Final Year"}{" "}
                    Evaluation
                  </Text>
                </Col>
                <Col style={{ paddingTop: "6px" }}>
                  {data?.isSubmit && (!data?.isEmployeeSubmit || !sign) ? (
                    <Tag
                      color="#EFF4FF"
                      icon={<EditOutlined style={{ color: "#004EEB" }} />}
                      style={{
                        borderRadius: "5px",
                        borderColor: "#84ADFF",
                        height: "25px",
                        lineHeight: "normal",
                        padding: "0 7px",
                        display: "inline-flex",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ color: "#004EEB" }}>Evaluated</span>
                    </Tag>
                  ) : (
                    <Tag
                      color="#A6F4C5"
                      icon={
                        <CheckCircleOutlined style={{ color: "#027A48" }} />
                      }
                      style={{
                        borderRadius: "5px",
                        borderColor: "#027A48",
                        height: "25px",
                        lineHeight: "normal",
                        padding: "0 7px",
                        display: "inline-flex",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ color: "#027A48" }}>Acknowledged</span>
                    </Tag>
                  )}
                </Col>
              </Row>
              <Text color="gray" level={6}>
                <CalendarOutlined /> Reviewed:{" "}
                {data?.supervisorSubmitDate
                  ? dayjs(data?.supervisorSubmitDate).format(DateFormat)
                  : " -"}
              </Text>
              <br />
              <br />
              <Row gutter={16}>
                <Col>
                  <Avatar
                    key={profile?.linkImage}
                    size={64}
                    src={profile?.linkImage}
                    style={{ backgroundColor: color.gray }}
                    icon={<UserOutlined />}
                  />
                </Col>
                <Col style={{ paddingTop: "8px" }}>
                  <Text fontWeight={600} level={5}>
                    {profile.firstname} {profile.lastname}
                  </Text>
                  <br />
                  <Text>{profile.position.positionName}</Text>
                </Col>
              </Row>
            </Col>
            <Col span={6}>
              <Contrainer
                style={{
                  borderRadius: "16px",
                  padding: "10px",
                  width: "100%",
                }}
              >
                <Row justify={"center"}>
                  <Text fontWeight={600} level={2}>
                    Final Score
                  </Text>
                </Row>
                <Row justify={"center"}>
                  <Text
                    fontWeight={600}
                    level={1}
                    color={
                      SCORE_MAPPING_COLOR[data?.pmsScores[0].pmsScoreValue]
                    }
                  >
                    {SCORE_MAPPING[data?.pmsScores[0].pmsScoreValue]}
                  </Text>
                </Row>
                <Row justify={"center"}>
                  <Text fontWeight={600} level={5}>
                    {SCORE_MAPPING_DES[data?.pmsScores[0].pmsScoreValue]}
                  </Text>
                </Row>
              </Contrainer>
            </Col>
          </Row>
        </Contrainer>
        <br />
        {((Number(data.pmsYear) == 2025 && Number(data.pmsMonth) == 14) ||
          Number(data.pmsYear) > 2025) && (
          <Contrainer
            style={{
              borderColor: color.gray,
              borderStyle: "solid",
              borderWidth: 1,
              borderRadius: "24px",
              padding: "20px",
            }}
          >
            <Row justify={"start"} gutter={8}>
              <Col>
                <Text level={4} fontWeight={700}>
                  💬 Manager's Feedback
                </Text>
              </Col>
            </Row>
            <br />
            <Contrainer
              style={{
                backgroundColor: "#FAFAFC",
                borderWidth: 1,
                borderRadius: "16px",
                padding: "16px",
                minHeight: "150px",
              }}
              html={data?.pmsOverall.replace(/\n/g, "<br/>")}
            />
          </Contrainer>
        )}
        <br />
        {!data?.isEmployeeSubmit || !sign ? (
          <Row justify={"center"}>
            <Button
              style={{ backgroundColor: color.navy, height: "40px" }}
              onClick={() => {
                setOpenAcknowledge(true);
                submitConsent();
              }}
            >
              <Text color="white" fontWeight={700}>
                Acknowledge
              </Text>
            </Button>
          </Row>
        ) : (
          <Contrainer
            style={{
              borderColor: color.green,
              borderStyle: "dashed",
              borderWidth: 1,
              borderRadius: "24px",
              padding: "20px",
              backgroundColor: "#F5FBF4",
            }}
          >
            <Row justify={"center"}>
              <img src={icon.acknowledgeIcon} style={{ height: "60px" }} />
            </Row>
            <Row justify={"center"}>
              <Text fontWeight={700} level={5}>
                <HighlightOutlined /> DIGITALLY ACKNOWLEDGED
              </Text>
            </Row>
            <Row justify={"center"} gutter={8}>
              <Col>
                <Text fontWeight={700} level={5}>
                  Employee Name:
                </Text>
              </Col>
              <Col>
                <Text fontWeight={400} level={5}>
                  {profile.firstname} {profile.lastname}
                </Text>
              </Col>
            </Row>
            <Row justify={"center"} gutter={8}>
              <Col>
                <Text fontWeight={700} level={5}>
                  Date time:
                </Text>
              </Col>
              <Col>
                <Text fontWeight={400} level={5}>
                  {dayjs(data?.employeeSubmitDate).format(DateFormat)}
                </Text>
              </Col>
            </Row>
          </Contrainer>
        )}
      </Contrainer>
      {openAcknowledge && (
        <Modal
          maskClosable={false}
          centered
          open={openAcknowledge}
          onCancel={() => {
            setOpenAcknowledge(!openAcknowledge);
            setSign(true);
            navigate("/consentPerformance", { state: { getData: data } });
          }}
          footer={false}
        >
          <Row justify={"center"}>
            <img src={icon.acknowledgeIcon} />
          </Row>
          <Row justify={"center"}>
            <Text fontWeight={700} level={3} style={{ color: "#12B76A" }}>
              Acknowledgement Complete
            </Text>
          </Row>
          <Row justify={"center"}>
            <Text color="gray" level={5}>
              Here’s your performance outcome
            </Text>
          </Row>
          <Row justify={"center"}>
            <Text fontWeight={700} level={4} color="black">
              Final Score
            </Text>
          </Row>
          <Row justify={"center"}>
            <Text
              fontWeight={700}
              level={1}
              color={SCORE_MAPPING_COLOR[data.pmsScores[0].pmsScoreValue]}
            >
              {SCORE_MAPPING[data.pmsScores[0].pmsScoreValue]}
            </Text>
          </Row>
          <Row justify={"center"}>
            <Text fontWeight={400} level={5}>
              {SCORE_MAPPING_DES[data.pmsScores[0].pmsScoreValue]}
            </Text>
          </Row>
          <br />
          <Contrainer
            style={{
              borderColor: color.green,
              borderStyle: "dashed",
              borderWidth: 1,
              borderRadius: "24px",
              padding: "20px",
            }}
          >
            <Row justify={"center"}>
              <Text fontWeight={700} level={4}>
                <HighlightOutlined /> DIGITALLY ACKNOWLEDGED
              </Text>
            </Row>
            <Row justify={"center"} gutter={8}>
              <Col>
                <Text fontWeight={700} level={4}>
                  Employee Name:
                </Text>
              </Col>
              <Col>
                <Text fontWeight={400} level={4}>
                  {profile.firstname} {profile.lastname}
                </Text>
              </Col>
            </Row>
            <Row justify={"center"} gutter={8}>
              <Col>
                <Text fontWeight={700} level={4}>
                  Date time:
                </Text>
              </Col>
              <Col>
                <Text fontWeight={400} level={4}>
                  {dayjs(Date.now()).format(DateFormat)}
                </Text>
              </Col>
            </Row>
          </Contrainer>
        </Modal>
      )}
    </>
  );
};
export default ConsentPerformance;
